import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02d0b3e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image" }
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("picture", _hoisted_1, [
    _createElementVNode("source", {
      srcset: _ctx.mediaData['galleryListProductModalGalleryMobileImage'] ? _ctx.mediaData['galleryListProductModalGalleryMobileImage'] : '',
      media: "(max-width:660px)"
    }, null, 8, _hoisted_2),
    _createElementVNode("source", {
      srcset: _ctx.mediaData['galleryListProductModalGalleryTabletImage'] ? _ctx.mediaData['galleryListProductModalGalleryTabletImage'] : '',
      media: "(max-width:1025px)"
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      src: _ctx.mediaData['galleryListProductModalGalleryDesktopImage'],
      alt: "banner"
    }, null, 8, _hoisted_4)
  ]))
}